"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EraSwapTokenFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var EraSwapTokenFactory = /** @class */ (function (_super) {
    __extends(EraSwapTokenFactory, _super);
    function EraSwapTokenFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    EraSwapTokenFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    EraSwapTokenFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    EraSwapTokenFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    EraSwapTokenFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    EraSwapTokenFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return EraSwapTokenFactory;
}(contracts_1.ContractFactory));
exports.EraSwapTokenFactory = EraSwapTokenFactory;
var _abi = [
    {
        inputs: [],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'spender',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'value',
                type: 'uint256',
            },
        ],
        name: 'Approval',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'previousOwner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'Paused',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'value',
                type: 'uint256',
            },
        ],
        name: 'Transfer',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'Unpaused',
        type: 'event',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'spender',
                type: 'address',
            },
        ],
        name: 'allowance',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'spender',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'approve',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'balanceOf',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'decimals',
        outputs: [
            {
                internalType: 'uint8',
                name: '',
                type: 'uint8',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'spender',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'subtractedValue',
                type: 'uint256',
            },
        ],
        name: 'decreaseAllowance',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'spender',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'addedValue',
                type: 'uint256',
            },
        ],
        name: 'increaseAllowance',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'name',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'pause',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'paused',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'renounceOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'symbol',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'totalSupply',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'recipient',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'transfer',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'sender',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'recipient',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'transferFrom',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'unpause',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
];
var _bytecode = '0x60806040523480156200001157600080fd5b5060408051808201825260078152660457261537761760cc1b602080830191825283518085019094526002845261455360f01b9084015281519192916200005b91600391620002f2565b50805162000071906004906020840190620002f2565b50506005805461ff001960ff19909116601217169055506000620000946200010a565b6005805462010000600160b01b031916620100006001600160a01b03841690810291909117909155604051919250906000907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0908290a35062000104336b1d6757f47b1c8ef70c0000006200010e565b6200039e565b3390565b6001600160a01b0382166200016a576040805162461bcd60e51b815260206004820152601f60248201527f45524332303a206d696e7420746f20746865207a65726f206164647265737300604482015290519081900360640190fd5b62000178600083836200021d565b62000194816002546200028260201b620009731790919060201c565b6002556001600160a01b03821660009081526020818152604090912054620001c79183906200097362000282821b17901c565b6001600160a01b0383166000818152602081815260408083209490945583518581529351929391927fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef9281900390910190a35050565b620002358383836200027d60201b620009d41760201c565b6200023f620002e4565b156200027d5760405162461bcd60e51b815260040180806020018281038252602a81526020018062001381602a913960400191505060405180910390fd5b505050565b600082820183811015620002dd576040805162461bcd60e51b815260206004820152601b60248201527f536166654d6174683a206164646974696f6e206f766572666c6f770000000000604482015290519081900360640190fd5b9392505050565b600554610100900460ff1690565b828054600181600116156101000203166002900490600052602060002090601f0160209004810192826200032a576000855562000375565b82601f106200034557805160ff191683800117855562000375565b8280016001018555821562000375579182015b828111156200037557825182559160200191906001019062000358565b506200038392915062000387565b5090565b5b8082111562000383576000815560010162000388565b610fd380620003ae6000396000f3fe608060405234801561001057600080fd5b506004361061011b5760003560e01c806370a08231116100b257806395d89b4111610081578063a9059cbb11610066578063a9059cbb14610317578063dd62ed3e14610343578063f2fde38b146103715761011b565b806395d89b41146102e3578063a457c2d7146102eb5761011b565b806370a0823114610289578063715018a6146102af5780638456cb59146102b75780638da5cb5b146102bf5761011b565b8063313ce567116100ee578063313ce5671461022d578063395093511461024b5780633f4ba83a146102775780635c975abb146102815761011b565b806306fdde0314610120578063095ea7b31461019d57806318160ddd146101dd57806323b872dd146101f7575b600080fd5b610128610397565b6040805160208082528351818301528351919283929083019185019080838360005b8381101561016257818101518382015260200161014a565b50505050905090810190601f16801561018f5780820380516001836020036101000a031916815260200191505b509250505060405180910390f35b6101c9600480360360408110156101b357600080fd5b506001600160a01b03813516906020013561042d565b604080519115158252519081900360200190f35b6101e561044a565b60408051918252519081900360200190f35b6101c96004803603606081101561020d57600080fd5b506001600160a01b03813581169160208101359091169060400135610450565b6102356104d7565b6040805160ff9092168252519081900360200190f35b6101c96004803603604081101561026157600080fd5b506001600160a01b0381351690602001356104e0565b61027f61052e565b005b6101c96105a8565b6101e56004803603602081101561029f57600080fd5b50356001600160a01b03166105b6565b61027f6105d1565b61027f6106a9565b6102c7610721565b604080516001600160a01b039092168252519081900360200190f35b610128610736565b6101c96004803603604081101561030157600080fd5b506001600160a01b038135169060200135610797565b6101c96004803603604081101561032d57600080fd5b506001600160a01b0381351690602001356107ff565b6101e56004803603604081101561035957600080fd5b506001600160a01b0381358116916020013516610813565b61027f6004803603602081101561038757600080fd5b50356001600160a01b031661083e565b60038054604080516020601f60026000196101006001881615020190951694909404938401819004810282018101909252828152606093909290918301828280156104235780601f106103f857610100808354040283529160200191610423565b820191906000526020600020905b81548152906001019060200180831161040657829003601f168201915b5050505050905090565b600061044161043a6109d9565b84846109dd565b50600192915050565b60025490565b600061045d848484610ac9565b6104cd846104696109d9565b6104c885604051806060016040528060288152602001610ede602891396001600160a01b038a166000908152600160205260408120906104a76109d9565b6001600160a01b031681526020810191909152604001600020549190610c24565b6109dd565b5060019392505050565b60055460ff1690565b60006104416104ed6109d9565b846104c885600160006104fe6109d9565b6001600160a01b03908116825260208083019390935260409182016000908120918c168152925290205490610973565b6105366109d9565b6005546201000090046001600160a01b0390811691161461059e576040805162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604482015290519081900360640190fd5b6105a6610cbb565b565b600554610100900460ff1690565b6001600160a01b031660009081526020819052604090205490565b6105d96109d9565b6005546201000090046001600160a01b03908116911614610641576040805162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604482015290519081900360640190fd5b6005546040516000916201000090046001600160a01b0316907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0908390a3600580547fffffffffffffffffffff0000000000000000000000000000000000000000ffff169055565b6106b16109d9565b6005546201000090046001600160a01b03908116911614610719576040805162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604482015290519081900360640190fd5b6105a6610d68565b6005546201000090046001600160a01b031690565b60048054604080516020601f60026000196101006001881615020190951694909404938401819004810282018101909252828152606093909290918301828280156104235780601f106103f857610100808354040283529160200191610423565b60006104416107a46109d9565b846104c885604051806060016040528060258152602001610f4f60259139600160006107ce6109d9565b6001600160a01b03908116825260208083019390935260409182016000908120918d16815292529020549190610c24565b600061044161080c6109d9565b8484610ac9565b6001600160a01b03918216600090815260016020908152604080832093909416825291909152205490565b6108466109d9565b6005546201000090046001600160a01b039081169116146108ae576040805162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604482015290519081900360640190fd5b6001600160a01b0381166108f35760405162461bcd60e51b8152600401808060200182810382526026815260200180610e706026913960400191505060405180910390fd5b6005546040516001600160a01b038084169262010000900416907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a3600580546001600160a01b0390921662010000027fffffffffffffffffffff0000000000000000000000000000000000000000ffff909216919091179055565b6000828201838110156109cd576040805162461bcd60e51b815260206004820152601b60248201527f536166654d6174683a206164646974696f6e206f766572666c6f770000000000604482015290519081900360640190fd5b9392505050565b505050565b3390565b6001600160a01b038316610a225760405162461bcd60e51b8152600401808060200182810382526024815260200180610f2b6024913960400191505060405180910390fd5b6001600160a01b038216610a675760405162461bcd60e51b8152600401808060200182810382526022815260200180610e966022913960400191505060405180910390fd5b6001600160a01b03808416600081815260016020908152604080832094871680845294825291829020859055815185815291517f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b9259281900390910190a3505050565b6001600160a01b038316610b0e5760405162461bcd60e51b8152600401808060200182810382526025815260200180610f066025913960400191505060405180910390fd5b6001600160a01b038216610b535760405162461bcd60e51b8152600401808060200182810382526023815260200180610e4d6023913960400191505060405180910390fd5b610b5e838383610dfd565b610b9b81604051806060016040528060268152602001610eb8602691396001600160a01b0386166000908152602081905260409020549190610c24565b6001600160a01b038085166000908152602081905260408082209390935590841681522054610bca9082610973565b6001600160a01b038084166000818152602081815260409182902094909455805185815290519193928716927fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef92918290030190a3505050565b60008184841115610cb35760405162461bcd60e51b81526004018080602001828103825283818151815260200191508051906020019080838360005b83811015610c78578181015183820152602001610c60565b50505050905090810190601f168015610ca55780820380516001836020036101000a031916815260200191505b509250505060405180910390fd5b505050900390565b600554610100900460ff16610d17576040805162461bcd60e51b815260206004820152601460248201527f5061757361626c653a206e6f7420706175736564000000000000000000000000604482015290519081900360640190fd5b6005805461ff00191690557f5db9ee0a495bf2e6ff9c91a7834c1ba4fdd244a5e8aa4e537bd38aeae4b073aa610d4b6109d9565b604080516001600160a01b039092168252519081900360200190a1565b600554610100900460ff1615610dc5576040805162461bcd60e51b815260206004820152601060248201527f5061757361626c653a2070617573656400000000000000000000000000000000604482015290519081900360640190fd5b6005805461ff0019166101001790557f62e78cea01bee320cd4e420270b5ea74000d11b0c9f74754ebdbfc544b05a258610d4b6109d9565b610e088383836109d4565b610e106105a8565b156109d45760405162461bcd60e51b815260040180806020018281038252602a815260200180610f74602a913960400191505060405180910390fdfe45524332303a207472616e7366657220746f20746865207a65726f20616464726573734f776e61626c653a206e6577206f776e657220697320746865207a65726f206164647265737345524332303a20617070726f766520746f20746865207a65726f206164647265737345524332303a207472616e7366657220616d6f756e7420657863656564732062616c616e636545524332303a207472616e7366657220616d6f756e74206578636565647320616c6c6f77616e636545524332303a207472616e736665722066726f6d20746865207a65726f206164647265737345524332303a20617070726f76652066726f6d20746865207a65726f206164647265737345524332303a2064656372656173656420616c6c6f77616e63652062656c6f77207a65726f45524332305061757361626c653a20746f6b656e207472616e73666572207768696c6520706175736564a2646970667358221220c7ed057aa269723b22732b9822d88adf7ce2f5d0d55af4f4d855fd91cf86cf6864736f6c6343000704003345524332305061757361626c653a20746f6b656e207472616e73666572207768696c6520706175736564';
//# sourceMappingURL=EraSwapTokenFactory.js.map